"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeptunianPowerConsultants = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const ResourceType_1 = require("../../ResourceType");
const Tags_1 = require("../Tags");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Resources_1 = require("../../Resources");
const TileType_1 = require("../../TileType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Size_1 = require("../render/Size");
class NeptunianPowerConsultants extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.NEPTUNIAN_POWER_CONSULTANTS,
            tags: [Tags_1.Tags.ENERGY],
            cost: 14,
            resourceType: ResourceType_1.ResourceType.HYDROELECTRIC,
            metadata: {
                cardNumber: 'X61',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When any ocean tile is placed, you MAY pay 5 M€ (steel may be used) to increase your energy production 1 step and add 1 hydroelectric resource here.', (eb) => {
                        eb.oceans(1, Size_1.Size.SMALL).any.startEffect.megacredits(-5).steel(1).brackets.production((pb) => pb.energy(1)).hydroelectric(1);
                    }).br;
                    b.vpText('1 VP per hydroelectric resource here.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.hydroelectric(1, 1),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    onTilePlaced(cardOwner, activePlayer, space) {
        if (cardOwner.hasConceded)
            return;
        if (!cardOwner.canAfford(5, { steel: true, plants: false }))
            return;
        cardOwner.game.defer(new DeferredAction_1.DeferredAction(cardOwner, () => {
            var _a;
            if (((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.OCEAN) {
                cardOwner.game.defer(new DeferredAction_1.DeferredAction(cardOwner, () => {
                    const orOptions = new OrOptions_1.OrOptions();
                    if (cardOwner.canAfford(5, { steel: true, plants: false })) {
                        orOptions.options.push(new SelectOption_1.SelectOption('Pay 5 M€ to increase energy production 1 step and gain 1 hydroelectric resource', 'Confirm', () => {
                            cardOwner.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(cardOwner, 5, { canUseSteel: true, title: 'Select how to pay for action' }), DeferredAction_1.Priority.COST);
                            cardOwner.addProduction(Resources_1.Resources.ENERGY, 1);
                            cardOwner.addResourceTo(this, { qty: 1, log: true });
                            return undefined;
                        }));
                    }
                    orOptions.options.push(new SelectOption_1.SelectOption('Do nothing', 'Confirm', () => {
                        return undefined;
                    }));
                    if (orOptions.options.length === 1) {
                        return orOptions.options[0].cb();
                    }
                    else {
                        activePlayer.game.log('${0} must resolve ${1} effect', (b) => b.player(cardOwner).card(this));
                    }
                    return orOptions;
                }), cardOwner.id !== activePlayer.id ? DeferredAction_1.Priority.OPPONENT_TRIGGER : undefined);
            }
            return undefined;
        }));
    }
    getVictoryPoints() {
        return this.resourceCount;
    }
}
exports.NeptunianPowerConsultants = NeptunianPowerConsultants;
//# sourceMappingURL=NeptunianPowerConsultants.js.map